<template>
  <mavon-editor
    class="markdown-viewer"
    :value="value"
    language="en"
    :boxShadow="false"
    :autofocus="false"
    :editable="false"
    :subfield="false"
    :toolbarsFlag="false"
    :transition="false"
    defaultOpen="preview"
    previewBackground="#fff"
  />
</template>

<script>
export default {
  name: 'MarkdownViewer',
  props: {
    value: {
      type: String,
      require: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .markdown-viewer {
    z-index: 1;
    border: none;
    padding: 0;
    min-height: 0;

    /deep/ .v-show-content {
      padding: 0!important;
    }
  }
</style>
